import React, { ReactNode } from "react";

interface ContainerRowProps{
    children: ReactNode
}

const ContainerRow: React.FC<ContainerRowProps> = (props: ContainerRowProps) => {
    const { children } = props ;
    return (
        <div className="row">
           <div className="mx-auto">
                <div className="col-lg-12 text-center">
                    <div className="row">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContainerRow;